// extracted by mini-css-extract-plugin
export const footer = "Footer-module--footer--3mBiF";
export const mainFooter = "Footer-module--main-footer--3qkVz";
export const footerLeft = "Footer-module--footer-left--2AkFU";
export const followUs = "Footer-module--follow-us--3PLSY";
export const footerBoxes = "Footer-module--footer-boxes--2a4l0";
export const ctaContainer = "Footer-module--cta-container--3u5Rc";
export const subscribe = "Footer-module--subscribe--122lH";
export const footerNavs = "Footer-module--footer-navs--o-q32";
export const contactUs = "Footer-module--contact-us--zu9-O";
export const subFooter = "Footer-module--sub-footer--1UMh0";
export const cdcDisclaimerContainer = "Footer-module--cdc-disclaimer-container--2GJcX";